<template>
  <div class="mt-10" data-testid="visitor-list">
    <div v-if="loading" class="flex justify-center py-10" data-testid="visitor-list-loading">
      <CircleSpinner />
    </div>
    <div
      v-else-if="visitors.length === 0"
      class="flex flex-col items-center justify-center py-10 text-center"
      data-testid="visitor-list-empty"
    >
      <template v-if="filtersActive">
        <p class="mt-6 text-headline-xs">{{ $t('VisitorProfiles.noVisitors') }}</p>
        <p class="mt-2 text-body-s">{{ $t('VisitorProfiles.noVisitorsDescription') }}</p>
      </template>
      <template v-else>
        <p class="mt-6 text-headline-xs">{{ $t('VisitorProfiles.noVisitorsSelected') }}</p>
        <p class="mt-2 text-body-s">{{ $t('VisitorProfiles.noVisitorsSelectedDescription') }}</p>
      </template>
    </div>
    <div v-else class="grid grid-cols-3 gap-6" data-testid="visitor-list-grid">
      <VisitorProfileCard v-for="visitor in visitors" :key="visitor.id" :visitor="visitor" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { CircleSpinner } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'

import VisitorProfileCard from '@/components/VisitorProfiles/VisitorProfileCard.vue'
import { VisitorProfileStatusEnum } from '@/gql/myomr'

import type { CompanyVisitorProfile, FilterType } from './types'

const props = defineProps<{
  visitors: CompanyVisitorProfile[]
  loading: boolean
  selectedFilters: Record<FilterType, string[]>
  status: VisitorProfileStatusEnum | undefined
}>()

const filtersActive = computed(() => {
  return Object.values(props.selectedFilters).some((filters) => filters.length > 0)
})
</script>
